import React, { FC, useEffect } from 'react';
import { Loaders } from 'components';
import { useParams } from 'react-router-dom';
import { useCognitoUser, useCurrentUser, useNotify } from 'hooks';
import { useCreateLoginTokenForCurrentUserInClientMutation } from 'api';
import * as paths from 'paths';
import { AUTH_DOMAIN } from 'settings';
import { queryString } from 'utilities';
import { Box, Button, Grid, Typography } from '@material-ui/core';

type ConnectParams = { network: string };

const Connect: FC = () => {
  const { network } = useParams<ConnectParams>();
  const currentUser = useCurrentUser();
  const auth = useCognitoUser();
  const isImpersonatingUser = auth.id !== currentUser.id;
  const notify = useNotify();
  const { mutate } = useCreateLoginTokenForCurrentUserInClientMutation({
    onError: notify.mutationError,
    onSuccess: ({ createLoginTokenForCurrentUserInClient }) => {
      const params = {
        user_id: currentUser.id,
        token: createLoginTokenForCurrentUserInClient,
        success_callback_url: `${window.location.origin}${paths.connectionSuccess}`,
        failure_callback_url: `${window.location.origin}${paths.connectionFailure}`,
        source: 'web sharing',
      };

      const url = `${AUTH_DOMAIN}/connect/${network}?${queryString(params)}`;
      location.replace(url);
    },
  });
  useEffect(() => {
    if (!isImpersonatingUser) {
      mutate({ client_id: currentUser.client_id });
    }
  }, [network]);

  if (isImpersonatingUser) {
    return (
      <Grid container direction="column" alignItems="center">
        <Grid item>
          <Box p={2}>
            <Typography>
              Connecting Social Accounts is not supported in impersonated mode.
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Button color="primary" variant="contained" onClick={() => window.close()}>
            Close Window
          </Button>
        </Grid>
      </Grid>
    );
  }
  return <Loaders.Standard />;
};

export default Connect;
